import type { NotificationRealtimeEvent } from '@/features/notifications/types';

type NotificationRealtimeClientOptions = {
  websocketUrl: string;
  onEvent: (event: NotificationRealtimeEvent) => void;
  onOpen?: () => void;
  onClose?: (event: CloseEvent) => void;
  onError?: (event: Event) => void;
};

export class NotificationRealtimeClient {
  private socket: WebSocket | null = null;

  constructor(private readonly options: NotificationRealtimeClientOptions) {}

  connect() {
    if (this.socket) {
      return;
    }

    const socket = new WebSocket(this.options.websocketUrl);
    this.socket = socket;

    socket.addEventListener('open', () => {
      this.options.onOpen?.();
    });

    socket.addEventListener('message', (event) => {
      try {
        this.options.onEvent(
          JSON.parse(event.data) as NotificationRealtimeEvent,
        );
      } catch {
        this.options.onEvent({
          type: 'notification.error',
          code: 'invalid_event_payload',
        });
      }
    });

    socket.addEventListener('close', (event) => {
      if (this.socket === socket) {
        this.socket = null;
      }

      this.options.onClose?.(event);
    });

    socket.addEventListener('error', (event) => {
      this.options.onError?.(event);
    });
  }

  disconnect() {
    this.socket?.close();
    this.socket = null;
  }
}
